//localStorage (set key i18nextLng=LANGUAGE)
import React, {useState} from "react";
import i18n from "i18next";
import {useT} from "../common/i18n";
import {Log} from "../common/log";
import gql from "graphql-tag";
import {useQuery} from "@apollo/react-hooks";



const QUERY_AVAILABLE_LANGUES = gql`query {getAvailableLanguages}`;


export const LanguageSelector = (props) => {
    const t = useT()
    let availableLanguages = null
    Log.Info("Selected language: ", i18n.language )
    const gqlResult = useQuery(QUERY_AVAILABLE_LANGUES);

    if (!gqlResult.loading){
        availableLanguages = gqlResult.data?.availableLanguages
    }

    if (availableLanguages) {
        return <select
            id="dropdown" onChange={(e) => i18n.changeLanguage(e.target.value)}>
            <option selected={i18n.language === "de"} value="de">DE</option>
            <option selected={i18n.language === "en"} value="en">EN</option>
        </select>
    }

    return <select
        id="dropdown" onChange={(e) => i18n.changeLanguage(e.target.value)}>
        {gqlResult.data?.getAvailableLanguages?.map((l) => {
          return <option key={l} selected={i18n.language === l} value={l}>{l.toUpperCase()}</option>
        })}
    </select>
}